export const TextAmountProducts = ({
  search,
  currentPage,
  searchProducts,
  totalProducts
}) => (
  <>
    {search ? (
      <>
        <span className="text-sm text-gray-dark mr-4 hidden lg:inline">
          Produto(s) encontrado(s): {currentPage} -{' '}
          {searchProducts.products.items.length} de {totalProducts}
        </span>
        <span className="text-sm text-gray-dark mr-4 lg:hidden">
          {currentPage} - {searchProducts.products.items.length} de{' '}
          {totalProducts}
        </span>
      </>
    ) : (
      <>
        <span className="text-sm text-gray-dark mr-4 hidden lg:inline">
          Itens ordenados por:
        </span>
      </>
    )}
  </>
);
